<nav class="header" [class.small]="small" [class.tiny]="tiny" [class.big]="big" [class.bigish]="bigish">
  <ng-content></ng-content>
</nav>
